import { render, staticRenderFns } from "./ExpandableItem.vue?vue&type=template&id=10386c8e&scoped=true"
import script from "./ExpandableItem.vue?vue&type=script&lang=js"
export * from "./ExpandableItem.vue?vue&type=script&lang=js"
import style0 from "./ExpandableItem.vue?vue&type=style&index=0&id=10386c8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10386c8e",
  null
  
)

export default component.exports